export const CUSTOM_SUBDOMAINS_HOSTNAME = [
  "staging-shapehomes.lottrackr.com.au",
  "shapehomes.lottrackr.com.au",
];
